import React, { useState } from 'react';
import './App.css';
import DiceSimulation from './components/DiceSimulation';
import LanguageSelector from './components/LanguageSelector';

function App() {
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
  };

  if (!selectedLanguage) {
    return <LanguageSelector onLanguageSelect={handleLanguageSelect} />;
  }

  return (
    <div className="App">
      <DiceSimulation language={selectedLanguage} />
    </div>
  );
}

export default App; 